export default "__VITE_ASSET__fe7f5db3__"